var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE5\xBE\xAA\xE7\x8E\xAF 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x9B\xBE\xE5\xB1\x82 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x9B\xBE\xE5\xB1\x82 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.93059 12.75H5.62214C5.00284 12.75 4.40891 12.491 3.97101 12.0299C3.5331 11.5689 3.28708 10.9435 3.28708 10.2915V3.25M7.5 3.25H10.669C11.2876 3.25 11.8808 3.50871 12.3182 3.96923C12.7556 4.42975 13.0013 5.05434 13.0013 5.70561V12.75M0.718994 5.97853L3.16615 3.40201L5.61331 5.97853M10.7401 10.2368L13.0013 12.6205L15.2653 10.2368",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepost);
export default __webpack_public_path__ + "static/media/repost.d4c3acd17106ccde2e51842b2734c375.svg";
export { ForwardRef as ReactComponent };